export const getISODateNow = () => (new Date()).toISOString()